

import React, { useEffect, useRef } from 'react';
import ReactPlayer from 'react-player';
import './LibraryVideo.css';
import { useData } from '../utils/DataContext';

const LibraryVideo = () => {
  const { selectedId } = useData();
  const contentRef = useRef(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const allChapters = [
    {
      id: 1,
      title: 'ಟಿನಿಟಸ್ ಯೋಗ',
      subChapters: [
        {
          id: 1,
          title: '',
          videos: [
            {
              id: 1,
              title: 'ಶ್ವಾಸಕ್ರಿಯೆ ೧',
              url: 'https://youtu.be/f7ltxpeEKNs?si=0vASBzwTrf85_4c6'
            },
            {
              id: 2,
              title: 'ಶ್ವಾಸಕ್ರಿಯೆ ೨',
              url: 'https://youtu.be/nUjwkC2pBb4?si=iLC0ENo9nAfwH8Lj'
            },
            {
              id: 3,
              title: 'ಅರ್ಧಚಕ್ರಾಸನ ಮತ್ತು ಪಾದಹಸ್ತಾಸನ: ಅಭ್ಯಾಸದ ವಿಧಾನ',
              url: 'https://youtu.be/9bqvLNXkU8Q?si=JXmjEgD1iIkf5wo_'
            },
            {
              id: 4,
              title: 'ಕಟೀಚಕ್ರಾಸನ ಅಭ್ಯಾಸದ ವಿಧಾನ',
              url: 'https://youtu.be/HNIWdvqBjWk?si=jJMXTjSxLIJTbeNL'
            },
            {
              id: 5,
              title: 'ವಿಭಾಗೀಯ ಪ್ರಾಣಾಯಾಮ',
              url: 'https://youtu.be/aEWv9KOgHg4?si=mZSsthqXbM84AZyT'
            },
            {
              id: 6,
              title: 'ಉಜ್ಜಾಯಿ ಪ್ರಾಣಾಯಾಮ',
              url: 'https://youtu.be/i69wrigKh8c?si=iSaI2v-XxyCnNY9q'
            },
            {
              id: 7,
              title: 'ನಾಡೀಶುದ್ಧಿ ಪ್ರಾಣಾಯಾಮ',
              url: 'https://youtu.be/5J63St4rbcE?si=b5QlSlZ9gZL-1JBX'
            },
            {
              id: 8,
              title: 'ಭಸ್ತ್ರಿಕ ಪ್ರಾಣಾಯಾಮ',
              url: 'https://youtu.be/1uFb94AB5Dw?si=EjeebxdSFiYF3dUQ'
            },
            {
              id: 9,
              title: 'ಕಪಾಲಭಾತಿ',
              url: 'https://youtu.be/NluJUX2Z6Ag?si=dOMPKKIYtBi6RHrs'
            },
            {
              id: 10,
              title: ' ವಿಶ್ರಾಂತಿ',
              url: 'https://youtu.be/2EHKM25pai4?si=6XLWmCk5PMODXxF0'
            },
          ],
        },
      ],
    },
    {
      id: 2,
      title: 'ವೆಸ್ಟಿಬ್ಯುಲರ್',
      subChapters: [
        {
          id: 1,
          title: 'ವೆಸ್ಟಿಬ್ಯುಲರ್ ವ್ಯಾಧಿಗಳಿಗೆ ಯೋಗ',
          videos: [
            {
              id: 1,
              title: 'ಬಿಂದು ತ್ರಾಟಕ',
              url: 'https://youtu.be/6syqLOIYMJo?si=ty4ajpb2GPp5I6gj'
            },
            {
              id: 2,
              title: 'ಕಣ್ಣನ್ನು ಕೇಂದ್ರೀಕರಿಸಿ ಕುತ್ತಿಗೆಯ ಚಲನೆ',
              url: 'https://youtu.be/_k6PpPCOGQg?si=L6E6d0C3xuXehqEV'
            },
            {
              id: 3,
              title: 'ಮೊಣಕೈೈ ಚಲನೆ',
              url: 'https://youtu.be/bcaiEcJoRKQ?si=JO1Zb9UY2kwtzlfw'
            },
            {
              id: 4,
              title: 'ಹಸ್ತದ ಮಣಿಗಂಟಿನ ಚಲನೆ',
              url: 'https://youtu.be/bcaiEcJoRKQ?si=yn7iwM6oYQaHwQDe'
            },
            {
              id: 5,
              title: 'ತಾಡಾಸನ',
              url: 'https://youtu.be/jJufQyn7ivo?si=s8fdimhvAQ2hnqix'
            },
            {
              id: 6,
              title: 'ಕುತ್ತಿಗೆ ಮತ್ತು ಕಣ್ಣಿನ ಚಲನೆ',
              url: 'https://youtu.be/Ml5MZSwM2lw?si=q-LMgHH8XXPpxn-_'
            },
            {
              id: 7,
              title: 'ಹುಳಿಯ ಉಸಿರಾಟದ ಕ್ರಿಯೆ',
              url: 'https://youtu.be/Ml5MZSwM2lw?si=sB4N69I0R3Z22LTu'
            },
            {
              id: 8,
              title: 'ಕೈಗಳನ್ನು ಚಾಚುವ ವ್ಯಾಯಾಮ',
              url: 'https://youtu.be/hgFwMK6jv-c?si=RxczJtLCWws3Df3l'
            },
            {
              id: 9,
              title: 'ಉಸಿರಾಟದ ವ್ಯಾಯಾಮಗಳು',
              url: 'https://youtu.be/hgrCg7ym77o?si=WwSzCYkrJXmS1adf'
            },
            {
              id: 10,
              title: 'ಪಾದದ ಮಣಿಗಂಟಿನ ಚಲನೆ',
              url: 'https://youtu.be/hgrCg7ym77o?si=tOYIkhYjFCxWfWVs'
            },
            {
              id: 11,
              title: 'ಮಂಡಿಯ ವ್ಯಾಯಾಮ',
              url: 'https://youtu.be/A2ieLQzODAQ?si=wYuzpD3OLLgknqkK'
            },
            {
              id: 12,
              title: 'ಸೊೊಂಟದ ಚಲನೆ',
              url: 'https://youtu.be/PLFYGVV22H8?si=V4jA3VotF143wzjn'
            },
            {
              id: 13,
              title: 'ಭುಜದ ಚಲನೆ',
              url: 'https://youtu.be/3A2aut5cAoQ?si=o-VKjaALHMUo2Hfd'
            },
            {
              id: 14,
              title: 'ಶಶಾಂಕಾಸನ ವ್ಯಾಯಾಮಗಳು',
              url: 'https://youtu.be/3A2aut5cAoQ?si=A54IH6ofp2-9sq6I'
            },
            {
              id: 15,
              title: 'ಅರ್ಧಕಟಿಚಕ್ರಾಸನ',
              url: 'https://youtu.be/T9ndpsifRTs?si=tK-7H0HrxQuK90Z4'
            },
            {
              id: 16,
              title: 'ತ್ರಿಕೋಣಾಸನ',
              url: 'https://youtu.be/VvoEi2DH_Kg?si=4I-fJivDpQukeB40'
            },
            {
              id: 17,
              title: 'ವೀರಭದ್ರಾಸನ',
              url: 'https://youtu.be/YTy8NyVClSI?si=cVP-afYtXWjpTLik'
            },
            {
              id: 18,
              title: 'ವಕ್ರಾಸನ',
              url: 'https://youtu.be/q56zfUigAbo?si=65rJVf3M-82fPSyq'
            },
            {
              id: 19,
              title: 'ಭುಜಂಗಾಸನ',
              url: 'https://youtu.be/q56zfUigAbo?si=_eaD22WP8uTyEtzy'
            },
            {
              id: 20,
              title: 'ಪವನಮುಕ್ತಸನ',
              url: 'https://youtu.be/oTzp5NFcp84?si=idNJ8pn_nMC2OyWW'
            },
            {
              id: 21,
              title: 'ವಿಭಾಗೀಯ ಪ್ರಾಣಾಯಾಮ',
              url: 'https://youtu.be/-BqUlAtaQkg?si=t02vgftohhUxES5y'
            },
            {
              id: 22,
              title: 'ಕಪಾಲಭಾತಿ ಪ್ರಾಣಾಯಾಮ',
              url: 'https://youtu.be/-BqUlAtaQkg?si=TZOF7ZK8rbesvOeC'
            },
            {
              id: 23,
              title: 'ನಾಡೀಶುದ್ಧಿ ಪ್ರಾಣಾಯಾಮ',
              url: 'https://youtu.be/_HsB3xjIezc?si=XMG_0O3ctoHtaoZ_'
            },
            {
              id: 24,
              title: 'ಭ್ರಮರಿ ಪ್ರಾಣಾಯಾಮ',
              url: 'https://youtu.be/_HsB3xjIezc?si=bLL3cVWRiLXifklI'
            },
            {
              id: 25,
              title: 'ವಿಶ್ರಾಂತಿ ಮತ್ತು ಪಠಣ',
              url: 'https://youtu.be/nMTtTxVTQuU?si=dNsOEqwnwHXc9yiM'
            },


          ],
        },
        {
          id: 2,
          title: 'ವೆಸ್ಟಿಬ್ಯುಲರ್ ಪುನರ್ವಸತಿ ಚಿಕಿತ್ಸೆಯಲ್ಲಿ ಒಳಗೊಂಡಿರುವ ಹಂತಗಳು ಯಾವುವು',
          videos: [
            {
              id: 1,
              title: 'ಹಂತ ೧',
              url: 'https://youtu.be/hNSt9iDjekE?si=dWz9-2mwPCAIKARi'
            },
            {
              id: 2,
              title: 'ಹಂತ ೨',
              url: 'https://youtu.be/hNSt9iDjekE?si=Euj8wHyKyM00_jXX'
            },
            {
              id: 3,
              title: 'ಹಂತ ೩',
              url: 'https://youtu.be/zBpvjuUkJOg?si=qoFA9IzjKhp9I7xy'
            },
            {
              id: 4,
              title: 'ಹಂತ ೪',
              url: 'https://youtu.be/bcaiEcJoRKQ?si=yn7iwM6oYQaHwQDe'
            },



          ],
        },
      ],
    },
    {
      id: 3,
      title: 'Auditory Verbal Therapy',
      subChapters: [
        {
          id: 1,
          title: '',
          videos: [
            {
              id: 1,
              title: 'Lings Sound',
              url: 'https://youtu.be/yvtZlVbTZY0'
            },
            {
              id: 2,
              title: 'Preparing Juice',
              url: 'https://youtu.be/YF0JhJHFIR4'
            },
            {
              id: 3,
              title: 'Food',
              url: 'https://youtu.be/yifIihi-xzk'
            },
            {
              id: 4,
              title: 'Zoo',
              url: 'https://youtu.be/4WuSJMomlDc'
            },
            {
              id: 5,
              title: 'Common Objects',
              url: 'https://youtu.be/v6QtwSG04y8'
            },
            {
              id: 6,
              title: 'Money Concept',
              url: 'https://youtu.be/Nlys-KC-2oY'
            },
          ],
        },
      ],
    },
    {
      id: 5,
      title: 'Cochlear Implants',
      subChapters: [
        {
          id: 1,
          title: 'How to use Cochlear Implant ',
          videos: [
            {
              id: 1,
              title: 'How to wear',
              url: 'https://youtube.com/shorts/_NLX5p0D6h0'
            },
            {
              id: 2,
              title: 'Parts of Cochlear Implant',
              url: 'https://youtube.com/shorts/PkD4T5YEFbw'
            },
            {
              id: 3,
              title: 'Switching on',
              url: 'https://youtube.com/shorts/Taqs5dXcKnk'
            },
            {
              id: 4,
              title: 'Charging batteries',
              url: 'https://youtube.com/shorts/fVwy9Ay3wr8'
            },
            {
              id: 5,
              title: 'Changing Program',
              url: 'https://youtube.com/shorts/aok98_-xwXE'
            },

          ],
        },
        {
          id: 2,
          title: 'Care and Maintenance',
          videos: [
            {
              id: 1,
              title: 'Microphone guard',
              url: 'https://youtube.com/shorts/cTFXjbW-ORU'
            },
            {
              id: 2,
              title: 'Coil wand',
              url: 'https://youtube.com/shorts/Gjt0DTNwaZY'
            },
            {
              id: 3,
              title: 'Dry aid Kit',
              url: 'https://youtube.com/shorts/zXHKmRT9CS0'
            },
            {
              id: 4,
              title: 'Monitor earphones',
              url: 'https://youtube.com/shorts/i_a8iM5ro_M'
            },
          

          ],
        },
         {
          id: 3,
          title: 'Dos and Donts',
          videos: [
            {
              id: 1,
              title: 'Dos',
              url: 'https://youtube.com/shorts/71ZF614I0A0'
            },
            {
              id: 2,
              title: 'Donts',
              url: 'https://youtube.com/shorts/52YSgKUL8o4'
            },
          ],
        },
          {
          id: 4,
          title: 'Troubleshooting',
          videos: [
            {
              id: 1,
              title: 'CI troubleshooting 1',
              url: 'https://youtube.com/shorts/ZXe0Nd-M3I0'
            },
            {
              id: 2,
              title: 'CI troubleshooting 2',
              url: 'https://youtube.com/shorts/sVpSS_YvzHc'
            },
            {
              id: 3,
              title: 'CI troubleshooting 3',
              url: 'https://youtube.com/shorts/6HpmB9TS4AI'
            },
            {
              id: 4,
              title: 'CI troubleshooting 4',
              url: 'https://youtube.com/shorts/4FiwMshnAfs'
            },
          

          ],
        },
      ],
    },
     {
      id: 6,
      title: 'Counselling',
      subChapters: [
        {
          id: 1,
          title: 'Understanding Hearing Aids',
          videos: [
            {
              id: 1,
              title: 'How to change batteries',
              url: 'https://youtube.com/shorts/w_HnUimTPq4'
            },
            {
              id: 2,
              title: 'How to wear Hearing Aids',
              url: 'https://youtube.com/shorts/L7q9Uhs5r2Q'
            },
            {
              id: 3,
              title: 'Parts of Hearing Aids',
              url: 'https://youtube.com/shorts/7U8XixPCwSU'
            },
            {
              id: 4,
              title: 'Parts of RIC',
              url: 'https://youtube.com/shorts/7ydrlv_J7xM'
            },
       

          ],
        },
        {
          id: 2,
          title: 'Care and Maintenance',
          videos: [
            {
              id: 1,
              title: 'Changing the tube',
              url: 'https://youtube.com/shorts/zIQWvYFD8xg'
            },
            {
              id: 2,
              title: 'How to change hearing aids',
              url: 'https://youtube.com/shorts/uLt4U6w-KaE'
            },
            {
              id: 3,
              title: 'Cleaning hearing aids',
              url: 'https://youtube.com/shorts/ssgDhpuilzo'
            },
            {
              id: 4,
              title: 'Hearing Aid box',
              url: 'https://youtube.com/shorts/YPNXP3vB1Yw'
            },
               {
              id: 5,
              title: 'Use dehumidifier box',
              url: 'https://youtube.com/shorts/38USvvVs9bo'
            },
          

          ],
        },
         {
          id: 3,
          title: 'Dos and Donts',
          videos: [
          
             {
              id: 1,
              title: 'Dont drop the hearing aids',
              url: 'https://youtube.com/shorts/qN8e_KgyCS8'
            },
             {
              id: 2,
              title: 'Dont wear hearing aids while raining',
              url: 'https://youtube.com/shorts/U-fb4NmUAk4'
            },
             {
              id: 3,
              title: 'Dont wear hearing aids during ear discharge',
              url: 'https://youtube.com/shorts/SBLTS0NnkWU'
            },
             {
              id: 4,
              title: 'Keep hearing aids away from children',
              url: 'https://youtube.com/shorts/AnI10qzjIco'
            },
             {
              id: 5,
              title: 'Keep hearing aids in box when not in use',
              url: 'https://youtube.com/shorts/ZWrZjwnJosI'
            },
             {
              id: 6,
              title: 'Keep hearing aids away from heat',
              url: 'https://youtube.com/shorts/6IqYl4vW6vU'
            },
             {
              id: 7,
              title: 'Keep hearing aids away from water',
              url: 'https://youtube.com/shorts/Vkh-_hVZSFM'
            },
             {
              id: 8,
              title: 'Keep hearing aids away from electronic devices',
              url: 'https://youtube.com/shorts/cqF5A3IqQRg'
            },
         
          ],
        },
          {
          id: 4,
          title: 'Troubleshooting',
          videos: [
            {
              id: 1,
              title: ' troubleshooting 1',
              url: 'https://youtube.com/shorts/2ILTL60gfQA'
            },
            {
              id: 2,
              title: 'troubleshooting 2',
              url: 'https://youtube.com/shorts/L3WcKgWHZ_k'
            },
           
          
          

          ],
        },
      ],
    },
  ];

  // Filter chapters based on selectedId
  const filteredChapters = selectedId
    ? allChapters.filter(chapter => chapter.id === selectedId)
    : allChapters;

  // Scroll to top when component mounts or selectedId changes
  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, [selectedId]);

  const handleVideoNavigation = (chapterId, subChapterId, videoId) => {
    const element = document.getElementById(`video-${chapterId}-${subChapterId}-${videoId}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      element.classList.add('highlight');
      setTimeout(() => {
        element.classList.remove('highlight');
      }, 1000);
    }
  };
  return (
    <div className="library-container">
      {/* Sidebar */}
      <div className="sidebar">
        <h2>Chapters</h2>
        {filteredChapters.map((chapter) => (
          <div key={chapter.id} className="chapter-sidebar">
            <span className="chapter-link">{chapter.title}</span>
            {chapter.subChapters?.map((subChapter) => (
              <div key={subChapter.id} className="subchapter-sidebar">
                <span className="subchapter-link">{subChapter.title}</span>
                <ul>
                  {subChapter.videos.map((video) => (
                    <li key={video.id}>
                      <a
                        href={`#video-${chapter.id}-${subChapter.id}-${video.id}`}
                        className="video-link"
                        onClick={(e) => {
                          e.preventDefault();
                          handleVideoNavigation(chapter.id, subChapter.id, video.id);
                        }}
                      >
                        {video.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* Content Area with ref */}
      <div className="content" ref={contentRef}>
        {filteredChapters.map((chapter) => (
          <div key={chapter.id} className="chapter-section">
            <h2 className="chapter-title">{chapter.title}</h2>
            {chapter.subChapters && chapter.subChapters.map((subChapter) => (
              <div
                key={subChapter.id}
                id={`subchapter-${chapter.id}-${subChapter.id}`}
                className="subchapter-section"
              >
                <h3 className="subchapter-title">{subChapter.title}</h3>
                <div className="video-grid-container">
                  {subChapter.videos.map((video) => (
                    <div
                      id={`video-${chapter.id}-${subChapter.id}-${video.id}`}
                      key={video.id}
                      className="video-item-card"
                    >
                      <ReactPlayer
                        className="video-element"
                        url={video.url}
                        controls
                        width="100%"
                        height="180px"
                      />
                      <h5 className="video-item-title">{video.title}</h5>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LibraryVideo;